/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED EDITOR : STYLES --------------- ++++++++++ */
export default {
	embededitor: {
        position: 'relative',
		marginBottom: pxToEm(20),
        '&.greyOut':{
            pointerEvents: 'none',
            filter: 'grayScale(1)',
            opacity: .4
        }
	}
};
